import React from 'react';
import TextField from '../shared/ppbn-textfield';
import '../../styles/createInvoice.css'
import { withStyles } from '@material-ui/core/styles';
import CurrencyInput from '../shared/CurrencyInput';
import PartsListForm from './PartsListForm';
import PaymentTypeSelectField from '../shared/payment-type-field';

const styles = theme => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },    
    textField: {
      marginLeft: 20,
      marginTop: 15,      
      marginRight: theme.spacing.unit,
      width: 200,
    },
    paymentTypeContainer: {
        paddingLeft: 20,
        paddingTop: 10,
        paddingBottom:10
    },
    serviceNotes: {
      marginLeft: 20,  
      marginRight: theme.spacing.unit,
      width: '655px',
    },
    menu: {
      width: 200,
    },
  });

class ShopInvoiceForm extends React.Component {        
    

    dateChanged = (id, value) => {
        this.props.handleChange({ target : { id, value } })
    }    
       
    paymentTypeChanged = (e) => {
        this.props.handleChange({ target : { id: 'paymentType', value: e.target.value } })
    }

    paymentAndChargeDetails() {        
        const { handleChange, classes } = this.props;
        return (
            <div className="payments">
                <div className='invoice-sub-header'>Payment and Charge Details</div>
                <div className={classes.paymentTypeContainer}>
                    <PaymentTypeSelectField
                        classes={classes.formControl}
                        value={this.props.paymentType || ''}
                        onChange={(e) => this.paymentTypeChanged(e)}
                    />
                </div>
                <div className="payment-details">  
                    <CurrencyInput
                        id='serviceTruckCharges'
                        type="number"
                        value={this.props.serviceTruckCharges}
                        className={classes.textField}
                        label='Service Truck Charges'
                        onChange={handleChange} />                  
                    <CurrencyInput
                        id='laborCharges'
                        type="number"
                        value={this.props.laborCharges}
                        className={classes.textField}
                        label='Labor Charges'
                        onChange={handleChange} />
                    <CurrencyInput
                        id='miscCharges'
                        type="number"
                        value={this.props.miscCharges}
                        className={classes.textField}
                        label='Miscellaneous Charges'
                        onChange={handleChange} />
                    <CurrencyInput
                        id='partsCharges'
                        type="number"
                        value={this.props.partsCharges}
                        className={classes.textField}
                        label='Parts Charges'
                        onChange={handleChange} />
                    <CurrencyInput
                        id='taxes'
                        type="number"
                        value={this.props.taxes}
                        className={classes.textField}
                        label='Taxes'
                        onChange={handleChange} />
                    <CurrencyInput
                        id='credits'
                        type="number"
                        value={this.props.credits}
                        className={classes.textField}
                        label='Credits'
                        onChange={handleChange} />
                    <TextField
                        value={this.props.paymentDate || ''}
                        label="Payment Date"
                        id='paymentDate'
                        InputLabelProps={{ shrink: true, }}
                        className={classes.textField}
                        onChange={(e) => this.dateChanged('paymentDate', e.target.value)}
                        type="date" />
                    <CurrencyInput
                        id='postedToReceivables'
                        type="number"
                        value={this.props.postedToReceivables}
                        className={classes.textField}
                        label='Posted To Receivables'
                        onChange={handleChange} />
                    <CurrencyInput
                        type="number"
                        id='invoiceTotal'
                        value={this.props.invoiceTotal}
                        className={classes.textField}
                        label='Invoice Total'
                        onChange={handleChange} />
                </div>      
            </div>
        )
    }

    render() {
        const { handleChange, classes, invoiceId } = this.props;        
        return (
            <div className="invoice-form-container">
                <div className='invoice-sub-header'>    
                    <div>General Details {invoiceId ? <span className='invoice-sub-header-invoice-number'>(Editing Invoice: {`S${invoiceId}`})</span>: null}</div>                  
                </div>
                <TextField
                    id="location"
                    value={this.props.location || ""}    
                    inputProps={ {maxLength : 45}}
                    className={classes.textField}
                    label="Location"
                    onChange={handleChange}
                    margin="normal"
                />
                <TextField
                    id="unit"       
                    className={classes.textField}
                    value={this.props.unit || ""}                    
                    inputProps={ {maxLength : 20}}
                    label="Unit"
                    onChange={handleChange}
                    margin="normal"
                />                
                <TextField
                    value={this.props.date || ''}
                    label="Date"
                    id='date'
                    InputLabelProps={{ shrink: true, }}
                    className={classes.textField}                    
                    onChange={(e) => this.dateChanged('date',e.target.value)}
                    type="date" />        
                <TextField
                    id="vehicle"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    value={this.props.vehicle || ""}
                    className={classes.textField}
                    inputProps={ {maxLength : 45}}                    
                    label="Vehicle"
                    onChange={handleChange}/>
                <TextField
                    id="vin"                    
                    value={this.props.vin || ""}
                    className={classes.textField}
                    inputProps={ {maxLength : 17}}
                    label="VIN"
                    onChange={handleChange}
                    margin="normal"
                />                
                <TextField
                    id="companyPO"
                    value={this.props.companyPO || ""}                    
                    inputProps={ {maxLength : 255}}                    
                    className={classes.textField}
                    label="Company PO"
                    onChange={handleChange} />
                <TextField
                    id="referenceNumber"
                    value={this.props.referenceNumber || ""}                    
                    inputProps={ {maxLength : 20}}
                    className={classes.textField}
                    label="Reference Number"
                    onChange={handleChange} />
                <TextField
                        id="mileage"
                        type="number"
                        value={this.props.mileage || ''}
                        className={classes.textField}
                        label="Mileage"
                        onChange={handleChange}
                    />
                <br />
                <br />
                <TextField
                    id='serviceNotes'                    
                    inputProps={ { maxLength : 1000 } }
                    value={this.props.serviceNotes}                    
                    className={classes.serviceNotes}
                    label='Service Notes'
                    rows={3}
                    rowsMax={5}
                    multiline={true}
                    variant="outlined"
                    onChange={handleChange} />     
                <div className='invoice-sub-header'>    
                    <div>Parts </div>                  
                </div>
                <PartsListForm parts={this.props.parts} onChange={handleChange}/>                    
                {this.paymentAndChargeDetails()}                 
            </div>
          )
    }
}

export default withStyles(styles)(ShopInvoiceForm);
